import {PagesStateType} from './types';

export const DefaultPagesState: PagesStateType = {
    className: 'page',
    chatInitialized: false,
    updateDataFromApi: false,
    thankYouPageContent: null,
    zchatLibLoaded: false,
    scrollTop: false,
};